import { render, staticRenderFns } from "./Affaires.vue?vue&type=template&id=15aba4a9&"
import script from "./Affaires.vue?vue&type=script&lang=js&"
export * from "./Affaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports